import type { FaireProductEntity } from "../../entity_types/product";

export const p_tt673pkfsc: FaireProductEntity = {
  token: "p_tt673pkfsc",
  type: "product",
  name: "Swedish Cloths - Blank/Unprinted",
  brandToken: "b_43ezgtu33e",
  brandName: "Cleaner Cloths",
  imageUrl:
    "https://cdn.faire.com/fastly/d4b272605990d26221a4d441298c4b75d5befb88159b6f61ba27ed7a961cf900.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/523a0c6220b54702e731baccde0e4e2b72aadb4aeac5671ad856c81356724634.jpeg",
    "https://cdn.faire.com/fastly/e5da6f656946a3533dcdbc6feb2333206f15f6a110aab9bfe05b146178accfd0.jpeg",
    "https://cdn.faire.com/fastly/891a3bd62f97c2a58f0b0ea382b2a31c9e428d150c5128f962edc95254a4dbbe.jpeg",
    "https://cdn.faire.com/fastly/4ae06d770810add9e7c118282e90901ad1645aeb94cc92546bad738d7d894b80.png",
    "https://cdn.faire.com/fastly/7fdee33249c61da0d17a90d109b2086325be8567001227cee2dd49ac1459be89.jpeg",
  ],
  priceDollars: 1,
  description:
    "Swedish cloths are all-purpose cleaning cloths, made in Sweden. Cloths are 70% cellulose, 30% cotton, and 100% eco-friendly. Their streak-free finish is ideal for cleaning any surface.\n\nCleaner in every way!\n\nAbsorbs 20 times its weight\nReplaces up to 17 rolls of paper towels\nWashable and reusable up to 200 times\nStreak-free finish \nBiodegradable and compostable\nMade by the Swedish company that invented the material \nPackaged in bulk to provide more savings, with less environmental impact",
  tags: [],
  msrpDollars: 2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:16.884Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
